export const ACTION_SHOW_ADD_FILE_TO_DASHBOARD_DIALOG = 'ACTION_SHOW_ADD_FILE_TO_DASHBOARD_DIALOG';
export const ACTION_HIDE_ADD_FILE_TO_DASHBOARD_DIALOG = 'ACTION_HIDE_ADD_FILE_TO_DASHBOARD_DIALOG';
export const ACTION_SET_SHOW_ADD_FILE_TO_DASHBOARD_DIALOG = 'ACTION_SET_SHOW_ADD_FILE_TO_DASHBOARD_DIALOG';

export const ACTION_ADD_FILE_TO_DASHBOARD = 'ACTION_ADD_FILE_TO_DASHBOARD';
